<!-- Modal Overlay -->
<div class="modal-overlay" (click)="cancel()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <h3 class="modal-title">Adjust Inventory</h3>
      <button class="modal-close" (click)="cancel()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Modal Body -->
    <form [formGroup]="adjustForm" (ngSubmit)="submit()" class="modal-body">
      <!-- Location Selection -->
      <div class="form-group">
        <label for="locationId" class="form-label">Location</label>
        <select id="locationId" formControlName="locationId" class="form-select">
          <option [ngValue]="null">Select a location...</option>
          <option *ngFor="let loc of locations" [ngValue]="loc.locationId">
            {{ loc.locationName }}
          </option>
        </select>
        <div *ngIf="locationId?.invalid && locationId?.touched" class="form-error">
          Location is required
        </div>
      </div>

      <!-- Action Type -->
      <div class="form-group">
        <label class="form-label">Action</label>
        <div class="radio-group">
          <label class="radio-label">
            <input type="radio" formControlName="action" value="Add">
            <span>Add Mats</span>
          </label>
          <label class="radio-label">
            <input type="radio" formControlName="action" value="Remove">
            <span>Remove Mats</span>
          </label>
        </div>
      </div>

      <!-- Mat Type -->
      <div class="form-group">
        <label class="form-label">Mat Type</label>
        <div class="radio-group">
          <label class="radio-label">
            <input type="radio" formControlName="matType" value="Wood">
            <span>Wood</span>
          </label>
          <label class="radio-label">
            <input type="radio" formControlName="matType" value="Poly">
            <span>Poly</span>
          </label>
        </div>
      </div>

      <!-- Bucket -->
      <div class="form-group">
        <label class="form-label">Bucket</label>
        <div class="radio-group">
          <label class="radio-label">
            <input type="radio" formControlName="bucketCd" value="Available">
            <span>Available</span>
          </label>
          <label class="radio-label">
            <input type="radio" formControlName="bucketCd" value="In_Transit">
            <span>In Transit</span>
          </label>
        </div>
      </div>

      <!-- Quantity -->
      <div class="form-group">
        <label for="quantity" class="form-label">Quantity</label>
        <input 
          type="number" 
          id="quantity" 
          formControlName="quantity" 
          class="form-input"
          placeholder="Enter quantity..."
          min="1"
        >
        <div *ngIf="quantity?.invalid && quantity?.touched" class="form-error">
          <span *ngIf="quantity?.errors?.['required']">Quantity is required</span>
          <span *ngIf="quantity?.errors?.['min']">Quantity must be greater than 0</span>
        </div>
      </div>

      <!-- Modal Actions -->
      <div class="modal-actions">
        <button type="button" class="btn btn-secondary" (click)="cancel()">
          Cancel
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="adjustForm.invalid">
          Confirm Adjustment
        </button>
      </div>
    </form>
  </div>
</div>
